import Vue from 'vue'
import store from '../auth/index'

export default new Vue({
  functional: true,
  data: () => ({
    apiUrl: process.env.COMPONENT_API
  }),
  methods: {
    async getCheckoutList (active) {
      const currentProduct = store.state.currentProduct
      const localeThumb = 'PT_BR'
      let status = 'INACTIVE'

      if (!currentProduct) {
        return []
      }

      if (active) {
        status = 'ACTIVE'
      }

      const checkoutList = await this.$http.get(this.apiUrl + 'product/' + currentProduct + '/checkoutLayout/?localeThumb=' + localeThumb + '&status=' + status)

      return checkoutList.data
    },
    async getTemplateList (showInactive) {
      let endpoint = this.apiUrl + 'templateLayout/'

      if (!store.state.currentProduct) {
        return []
      }

      if (showInactive) {
        endpoint += 'forceInactives/'
      }

      const templateList = await this.$http.get(endpoint)

      return templateList.data
    },
    async checkoutActiveToggle (checkoutId) {
      const isPublished = await this.$http.put(this.apiUrl + 'checkoutLayout/publish/' + checkoutId)

      return isPublished
    },
    async getCheckoutData (checkoutId) {
      const checkoutData = await this.$http.get(this.apiUrl + 'checkoutLayout/' + checkoutId)

      return checkoutData
    },
    async activeCurrentCheckout (checkoutId, offerList) {
      const activeCurrentData = {
        idCheckout: checkoutId,
        idProduct: parseInt(store.state.currentProduct, 10),
        offerList: offerList || null
      }

      await this.$http.put(this.apiUrl + 'checkoutLayout/activate', activeCurrentData)
    },
    async deactivateCheckout (checkoutId) {
      const checkoutData = {
        idCheckout: checkoutId
      }

      await this.$http.put(this.apiUrl + 'checkoutLayout/desactivate', checkoutData)
    },
    async deleteCheckout (checkoutId, couponId) {
      const deleteCheckoutURL = new URL(this.apiUrl + 'checkoutLayout/' + checkoutId)

      if (couponId) {
        deleteCheckoutURL.searchParams.set('couponId', couponId)
      }

      await this.$http.delete(deleteCheckoutURL.toString())
    },
    async deleteTemplate (templateId) {
      await this.$http.delete(this.apiUrl + 'templateLayout/' + templateId)
    },
    async changeTemplateStatus (templateId, status) {
      await this.$http.post(this.apiUrl + 'templateLayout/changeStatus', {
        idTemplateLayout: templateId,
        active: status
      })
    },
    async getHotlinks (checkoutId) {
      const hotlinksList = await this.$http.get(this.apiUrl + 'checkoutLayout/' + checkoutId + '/hotlinks')

      return hotlinksList
    }
  }
})
